import { AppBar, Typography, Toolbar, IconButton, BottomNavigation, BottomNavigationAction } from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import SearchIcon from "@material-ui/icons/Search";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import SettingsIcon from "@material-ui/icons/Settings";
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import React from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { MenuDrawer } from "../components";
import "../styles/navStyles.css";

const Head = props => {
    const handleBack = () => {
        // props.history.goBack();
        if (typeof props.history !== 'undefined') {
            props.history.goBack();
        } else {
            return false;
        }
    }

    let cmeYears = null;

    if (typeof props.user_details !== 'undefined' && typeof props.user_details.labstest !== 'undefined') {
        cmeYears = props.user_details.cmeYears;
    }

    if (props.auth) {
        const { iconOne, iconTwo, headerText, backgroundcolor } = props;
        const iconSelector = icon => {
            switch (icon) {
                case "menu":
                    return (
                        <MenuDrawer 
                            className="headerIcons firstButton"
                            edge="start"
                            aria-lablel="firstIcon"
                            cmeYears={cmeYears}
                            location={props.location}
                        />
                    );

                case "back":
                    return (
                        <IconButton
                            className="firstButton"
                            edge="start"
                            aria-label="firstIcon"
                            onClick={handleBack}
                        >
                            <ArrowBackIosIcon className="headerIcons" />
                        </IconButton>
                    )

                case "search":
                    return (
                        <IconButton
                            className="firstButton"
                            edge="start"
                            aria-label="firstIcon"
                        >
                            <SearchIcon className="headerIcons" />
                        </IconButton>
                    );
                case "home":
                    return (
                        <IconButton
                            className="firstButton"
                            edge="start"
                            aria-label="firstIcon"
                        >
                            <Link
                                to={{
                                    pathname: "/home"
                                }}
                            >
                                <HomeIcon className="headerIcons" />
                            </Link>
                        </IconButton>
                    );

                case "profile":
                    return (
                        <IconButton
                            className="firstButton"
                            edge="start"
                            aria-label="firstIcon"
                        >
                            <Link
                                to={{
                                    pathname: "/profile"
                                }}
                            >
                                <AccountCircleIcon className="headerIcons" />
                            </Link>
                        </IconButton>
                    );

                case "settings":
                    return (
                        <IconButton
                            className="firstButton"
                            edge="start"
                            aria-label="firstIcon"
                        >
                            <Link
                                to={{
                                    pathname: "/settings"
                                }}
                            >
                                <SettingsIcon className="headerIcons" />
                            </Link>
                        </IconButton>
                    );
                default:
                    return (
                        <IconButton
                            className="firstButton"
                            edge="start"
                            aria-label="firstIcon"
                        >
                             
                        </IconButton>
                    );
            }
        };

        return (
            <AppBar className="appBar" position="static">
                <Toolbar>
                    {iconSelector(iconOne)}

                    <Typography className="title" variant="h6">
                        {headerText || "SASP"}
                    </Typography>

                    {iconSelector(iconTwo)}
                </Toolbar>
            </AppBar>
        );
    } else {
        return null;
    }
};

const mapStateToProps = state => {
    const { auth, user_details } = state.auth;
    const { headerText, iconOne, iconTwo, backgroundcolor } = state.style;
    return { headerText, iconOne, iconTwo, auth, backgroundcolor, user_details };
};

const Header = connect(mapStateToProps)(withRouter(Head));

export { Header }
